import { cardStatusConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  params: null,
  fetched: false,
  response: null,
  error: null
};

export const cardStatus = (state = initialState, action) => {
  switch (action.type) {
    case cardStatusConstants.GET_CARDSTATUS_REQUEST:
      return {
        ...state,
        response: null,
        params: action.params,
        fetching: true
      };
    case cardStatusConstants.GET_CARDSTATUS_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case cardStatusConstants.GET_CARDSTATUS_FAILURE:
      return {
        ...state,
        response: null,
        fetching: false,
        fetched: false,
        error: action.error
      };
    case cardStatusConstants.GET_CARDSTATUS_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
